<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 px-4 py-12">
      <section class="mx-auto w-full max-w-md space-y-6">
        <div class="space-y-3 text-center">
          <h1 class="text-3xl font-semibold text-slate-900">Logi sisse</h1>
          <p class="text-sm text-slate-500">
            Jätka oma halduspaneeli ja postituste kasutamisega.
          </p>
        </div>

        <form
          @submit.prevent="login"
          class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8"
        >
          <div class="space-y-5">
            <div class="space-y-2">
              <label for="email" class="text-sm font-semibold text-slate-700">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Email"
                v-model.trim="email"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>

            <div class="space-y-2">
              <label for="password" class="text-sm font-semibold text-slate-700">Salasõna</label>
              <input
                id="password"
                type="password"
                placeholder="Salasõna"
                v-model.trim="password"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>
          </div>

          <div class="mt-8 space-y-3">
            <button
              type="submit"
              class="inline-flex w-full items-center justify-center rounded-xl bg-brand px-4 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-brand/20 transition hover:bg-brand-dark focus:outline-none focus:ring-4 focus:ring-brand/40"
            >
              Logi sisse
            </button>
            <router-link
              to="/signup"
              class="inline-flex w-full items-center justify-center rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold uppercase tracking-wide text-slate-600 transition hover:border-brand/40 hover:text-brand focus:outline-none focus:ring-4 focus:ring-brand/30"
            >
              Loo konto
            </router-link>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async login() {
      const payload = { email: this.email, password: this.password };
      try {
        const response = await fetch("http://localhost:3000/auth/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error(`Login failed: ${response.status}`);
        }
        await response.json();
        location.assign("/");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped></style>
